import { Link } from "react-router-dom";
import NotFound from "../assets/404.jpeg";

const NotFoundPage = () => {
  return (
    <div className="bg-white flex justify-center pt-24 sm:pt-20 md:pt-20 lg:pt-20 xl:pt-20">
      <div className="w-full max-w-5xl">
        <Link to="/" className="block">
          <img
            src={NotFound}
            alt="404 Page Not Found"
            className="w-full h-auto object-contain cursor-pointer"
          />
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;